import style from "./style.scss";

import Link from "../link";

const Footer = () => (
  <footer class={style.footer}>
    <div>
      <div class={style.links}>
        <Link
          target="_blank"
          rel="noreferrer"
          href="https://www.facebook.com/groups/618929933832686/"
        >
          Klahanie Facebook Group
        </Link>
        <ul>
          <li>
            <Link
              href="https://klahanie.ivotehoa.com/register"
              target="_blank"
              rel="noreferrer"
            >
              Vote Online
            </Link>
          </li>
          <li>
            <Link
              target="_blank"
              rel="noreferrer"
              href="https://www.klahanie.com/"
            >
              Klahanie HOA
            </Link>
          </li>
          <li>
            <Link
              target="_blank"
              rel="noreferrer"
              href="https://www.klahanie.com/residentportal"
            >
              Resident Portal
            </Link>
          </li>
          <li>
            <Link
              target="_blank"
              rel="noreferrer"
              href="https://www.klahanie.com/overview"
            >
              Bylaws
            </Link>
          </li>
        </ul>
      </div>

      <div class={style.legal}>
        <p class={style.disclaimer}>
          This website is not officially affiliated with or endorsed by the
          Klahanie Homeowners Association.
        </p>
        <div class={style.copyright}>© {new Date().getFullYear()}</div>
      </div>
    </div>
  </footer>
);

export default Footer;
